import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./views/login/login.component'),
  },
  {
    path: 'config',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/config/config.component'),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/dashboard/dashboard.component'),
  },
  {
    path: 'kpis',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/kpis/kpi-overview.component'),
  },
  {
    path: 'readme',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'help',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/help/help.component'),
  },
  {
    path: 'journal',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/journal/journal.component'),
  },
  {
    path: 'alerts',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/alerts/alerts.component'),
  },
  {
    path: 'hurricanes',
    canActivate: [authGuard],
    loadComponent: () => import('./views/hurricanes/hurricanes.component'),
  },
  {
    path: 'data',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/data/data.component'),
  },
  {
    path: 'forecasts',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/forecasts/forecasts.component'),
  },
  {
    path: 'postprocessing',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/postprocessing/postprocessing.component'),
  },
  {
    path: 'imo-packages',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/imo-packages/imo-packages.component'),
  },
  {
    path: 'account',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./views/account/account.component'),
  },
  { path: '**', redirectTo: 'dashboard' },
];
